import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CareerPlan, CareerPlanSkill, CompletedCareerPlan } from 'src/app/models/career-plans';
import { CareerPlanHistoryService } from '../career-plan-history.service';
import { Subject } from 'rxjs';
import { CareerPlansApiService } from 'src/app/services/api/career-plans-api.service';
import { filter, takeUntil } from 'rxjs/operators';
import { CareerPlansService } from 'src/app/services/career-plans.service';
import { ResizeService } from 'src/app/services/resize.service';

@Component({
  selector: 'career-plan-history-item',
  templateUrl: './career-plan-history-item.component.html',
  styleUrls: ['./career-plan-history-item.component.scss'],
})
export class CareerPlanHistoryItemComponent implements OnInit {
  completedCareerPlan: CompletedCareerPlan;

  careerPlan: CareerPlan;
  skillRows: CareerPlanSkill[][] = [];

  @Output()
  emitCertificate = new EventEmitter<string>();

  private unsubscribe: Subject<void> = new Subject();
  careerPlanLabel: string = 'careerPlans.label';

  constructor(
    private route: ActivatedRoute,
    private careerPlanHistoryService: CareerPlanHistoryService,
    private careerPlansService: CareerPlansService,
    private resizeService: ResizeService
  ) {}

  ngOnInit(): void {
    this.careerPlan = this.route.snapshot.data['careerPlan'];

    this.skillRows = this.careerPlansService.updateSkillRows(this.resizeService.getCurrentScreenBreakpoint(), this.careerPlan, this.skillRows);

    this.resizeService.getDeviceChangeObs()
      .subscribe(bp => this.skillRows = this.careerPlansService.updateSkillRows(bp, this.careerPlan, this.skillRows));
  }

  goBack() {
    history.back();
  }

  downloadCertificate(certificateUrl) {
    this.careerPlanHistoryService.downloadCertificate(certificateUrl);
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
